class ArsivHareketleriAramaKriterleri {
    searchText?: string = "";
    protokolOnEk?: string = "";
    protokolYil?: number = null;
    protokolNo?: number = null;
};

export default ArsivHareketleriAramaKriterleri;